import { Slot, Stack } from "expo-router";

import { isWeb } from "@stepapp/core";
import { palette, spacing } from "@stepapp/ui";

const CalendarLayout = () => {
  return (
    <>
      {isWeb ? (
        <Slot />
      ) : (
        <Stack
          screenOptions={{
            headerShown: false,
            contentStyle: {
              backgroundColor: palette.common.white,
            },
          }}
        >
          <Stack.Screen name="index" options={{ headerShown: false }} />
          <Stack.Screen
            name="completed"
            options={{
              headerShown: false,
              contentStyle: {
                backgroundColor: palette.common.white,
              },
            }}
          />
          <Stack.Screen
            name="retry-payment"
            options={{
              animation: "slide_from_bottom",
              presentation: "modal",
              contentStyle: {
                backgroundColor: palette.common.white,
                paddingHorizontal: spacing.unit * 2.5,
              },
            }}
          />
        </Stack>
      )}
    </>
  );
};

export default CalendarLayout;
